import React from 'react';

const toastStyles = {
  success: 'bg-emerald-600 text-white',
  error: 'bg-red-600 text-white',
  info: 'bg-slate-800 text-white',
  warning: 'bg-amber-500 text-black',
};

const Toast = ({ visible, message, type = 'info', onClose }) => {
  if (!visible) return null;

  return (
    <div className="fixed right-4 top-4 z-50">
      <div
        className={[
          'flex min-w-[280px] max-w-sm items-start gap-3 rounded-lg px-4 py-3 shadow-lg',
          'border border-white/10 backdrop-blur',
          toastStyles[type] || toastStyles.info,
        ].join(' ')}
      >
        <div className="flex-1 text-sm font-medium leading-5">{message}</div>

        <button
          type="button"
          onClick={onClose}
          className="ml-2 rounded-md px-2 py-1 text-sm font-semibold opacity-80 transition hover:opacity-100"
          aria-label="Close toast"
        >
          ×
        </button>
      </div>
    </div>
  );
};

export default Toast;

